module.exports = {
  visibility: false,
  menuEntry: 'addons',
  alias: ['addons'],
  defaultName: {
    de: 'Shop',
    en: 'Shop'
  },
  title: {
    en: 'Addons',
    de: 'Zusatzprodukte'
  },
  icon: 'inbox',
  iconPrefix: 'fas',
  color: '#707070',
  badgeColor: 'gray',
  defaultItems: {
    'SHPADD': 1
  },
  tabs: [
       {
         intro: {
           style: 'alert alert-info',
           de: 'Im Folgenden handelt es sich um Listenpreise. Sofern Rabatte vorliegen, werden diese erst im Warenkorb abgezogen.',
           en: 'The following amounts are list prices. Discounts are applied in the cart, if available.'
         },
         id: 'addons',
         title: {
           en: 'Addons',
           de: 'Zusatzprodukte'
         },
         type: 'addons',
         hidePrices: false,
         category: 'chew',
         categoryPicker: true,
       },
       {
         id: 'cart',
         type: 'cart',
         title: {
           en: 'Cart',
           de: 'Warenkorb'
         },
         hideOrdered: true,
         requireShipping: false,
         orderDialog: [
           {
             id: 'terms',
             label: {
               de: 'Bedingungen',
               en: 'Terms'
             },
             intro: {
               style: 'alert alert-warning',
               en: 'Please confirm your order',
               de: 'Bitte bestätigen Sie Ihre Bestellung'
             },
             form: [
               {
                 id: 'terms',
                 type: 'checkbox',
                 checkValue: true,
                 required: true,
                 label: {
                   en: 'I have read and accepted the <a href="https://www.orehab-minds.com/agb/" target="_blank">terms of service</a>.',
                   de: 'Ich habe die <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert'
                 }
               },
               {
                 id: 'privacy',
                 type: 'checkbox',
                 required: true,
                 checkValue: true,
                 label: {
                   en: 'I have read and accepted the <a href="https://www.orehab-minds.com/agb/" target="_blank">pricacy policy</a>.',
                   de: 'Ich habe die <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Datenschutzhinweise</a> gelesen und akzeptiert'
                 }
               }
             ]
           }
         ]
       }
     ]
   };
